import * as jQuery from 'jquery';
import { acscriptsAddress } from './appconfig';

const jQueryString = 'jQuery';
const $String = '$';
global[jQueryString] = jQuery;
global[$String] = jQuery;

// injectScript(publicUrl('js/acscripts.kendo.all.min.js'));
injectScript(publicUrl('js/bootstrap.min.js'));
// injectScript(publicUrl('js/perfect-scrollbar.min.js'));
// injectScript(publicUrl('js/slick.min.js'));

$.ajaxPrefilter((options) => {
    if (options.url && options.url.startsWith(acscriptsAddress.ERX + 'api/prescriptionReport')) {
        options.xhrFields = {
            withCredentials: true
        };
    }
});

function injectScript(url: string) {
    var script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
}

function publicUrl(relativePathInPublicFolder: string, versioned: boolean = true) {
    const url = process.env.PUBLIC_URL + '/' + relativePathInPublicFolder;
    const vParam = versioned ? '?v=' + process.env.REACT_APP_VERSION : '';
    return url + vParam;
}


// WEBPACK FOOTER //
// ./src/configGlobal.ts